import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IDocument, Document } from '../Document.ts';
import { DocumentApi } from '../../../apis/Documents/DocumentApi.ts';
import { patientStore } from '../../../Store/Store.ts';

export function usePutDocumentMutations() {
    const queryClient = useQueryClient();
    const patientId = patientStore.patientId;

    return useMutation({
        mutationKey: [QueryKeys.documents, QueryKeys.document],

        mutationFn: async ({ id, document }: { id: number; document: IDocument }) => {
            await DocumentApi.putDocument(id, document);
            return document;
        },

        onSuccess: (data: IDocument) => {
            queryClient.setQueryData<Document[]>([QueryKeys.documents, patientId], (prev) => {
                if (!prev) return [];
                return prev.map((event) => (event.id === data.id ? new Document(data) : event));
            });
            queryClient.setQueryData<Document>([QueryKeys.document, data.id.toString()], () => {
                return new Document(data);
            });
        },
    });
}
